import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import DownloadApp from '../../components/DownloadApp';
import LoadingPage from '../../components/LoadingPage';
import {
  CommitmentStickerFlow,
  EntryPoint,
  ShareCardStatus,
  useShareCard,
} from '../../components/StoryShare';
import storyTexts from '../../components/StoryShare/texts.json';
import useLogger from '../../hooks/useLogger';
import { EventTypes } from '../../utils/events';

import {
  Message,
  MessageBody,
  MessageTitle,
  Page,
} from './styles';

const texts = storyTexts.sharePage;

/**
 * The page a client's phone opens from the QR code their computer showed after checkout. Anyone with the link
 * can open it, so it reads only the challenge's public details and never asks who the visitor is.
 */
const ChallengeSharePage = () => {
  const { challengeId } = useParams();
  const { status, card } = useShareCard(challengeId);
  const { logEvent } = useLogger();

  useEffect(() => {
    logEvent(EventTypes.STORY_SHARE_PAGE_OPENED, { challengeId });
  }, [challengeId, logEvent]);

  if (status === ShareCardStatus.LOADING) {
    return <LoadingPage />;
  }

  if (status === ShareCardStatus.UNAVAILABLE) {
    return (
      <Page $isDarkTheme>
        <Message>
          <MessageTitle>{texts.inactiveTitle}</MessageTitle>
          <MessageBody>{texts.inactiveBody}</MessageBody>
          <DownloadApp />
        </Message>
      </Page>
    );
  }

  return (
    <Page $isDarkTheme={card.isDarkTheme}>
      <CommitmentStickerFlow card={card} entryPoint={EntryPoint.QR} />
    </Page>
  );
};

export default ChallengeSharePage;
